"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import "./Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("")

  const handleSubscribe = (e) => {
    e.preventDefault()
    if (email) {
      alert("Thank you for subscribing!")
      setEmail("")
    }
  }

  return (
    <>
      <footer className="footer_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="footer-column">
                <div className="footer_logo">
                  <Link to="/">
                    <img src="../images/logo_new.png" className="fade-rounded-image" alt="Dr. Sunil Apsingi Logo" />
                  </Link>
                </div>
                <p className="footer-description">
                  Leading orthopedic surgeon with over 23 years of experience in joint replacement and sports medicine.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div className="footer-column">
                <h3 className="footer-title">Contact Us</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <i className="fa fa-map-marker"></i>
                    <span>Hyderabad, Telangana</span>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-phone"></i>
                    <span>+91 8341555765</span>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-envelope"></i>
                    <span>contact@arthroscopydoc.com</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div className="footer-column">
                <h3 className="footer-title">Quick Links</h3>
                <ul className="footer-links">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/aboutus">About Us</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/blogs">Blogs</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div className="footer-column">
                <h3 className="footer-title">Newsletter</h3>
                <p className="newsletter-text">Subscribe to get the latest updates and health tips.</p>
                <form onSubmit={handleSubscribe} className="newsletter-form">
                  <input
                    type="email"
                    className="newsletter-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="newsletter-btn">
                    Subscribe
                  </button>
                </form>
                <div className="social-links">
                  <a
                    href="https://www.youtube.com/channel/UCAJw_WKgtOHK20IDvGZYcvA"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <i className="fa fa-youtube-play"></i>
                  </a>
                  <a href="https://twitter.com/sapsingi" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCAJw_WKgtOHK20IDvGZYcvA"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCAJw_WKgtOHK20IDvGZYcvA"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="copyright_section">
        <div className="container">
          <p className="copyright_text">
            © 2025 Dr. Sunil Apsingi. All Rights Reserved. Design by{" "}
            <a href="https://instagram.com/sayikumarr" target="_blank" rel="noopener noreferrer">
              Sayikumarr
            </a>
          </p>
        </div>
      </div>
    </>
  )
}

export default Footer
